<template>
  <main class="modal-main">
    <div class="prod-popup no-padding">
      <div class="step-padding">
        <div class='t_999 t_center fs-26'>第 2 步 (共 2 步)</div>
        <div class='t_title'>返回拼多多APP进行付款后，复制订单编号，回到此页面，点击提交订单</div>
        <div class='t_hlep no-border'>如有疑问，请点击 <span class='t_blue' @click="showCourse">常见问题</span></div>
      </div>
      <div class="step-padding mar-top">
        <div style="overflow: hidden;">
          <div class='step_two'>
            <div class='step_img' @click='previewImg'><img :src='youpPath + step3Img' alt=""/></div>
          </div>
        </div>
      </div>
    </div>
    <div class='tc_button'>
      <div class='tc_btn primary' @click="prevStep">上一步</div>
      <div class='tc_btn shPrimaryBtn' @click="entoOrderMerge">提交订单</div>
    </div>
    <preview-dialog
      v-if="previewDialogShow"
      @close="previewDialogShow = false"
      :img-src="youpPath + step3Img">
    </preview-dialog>
  </main>
</template>

<script>
import { IMG_BASE_URL } from '@/config'
import { Toast } from 'mint-ui'
import PreviewDialog from '@/components/puppetComponent/PreviewDialog'

export default {
  data () {
    return {
      youpPath: IMG_BASE_URL,
      step3Img: '/upaiyun/Sys/20200107/5267805132417925554.jpg',
      previewDialogShow: false
    }
  },
  components: {
    PreviewDialog
  },
  mounted () {
    if (!this.$route.query.readyTaskId) {
      Toast('无任务id')
      this.$router.go(-1)
    }
  },
  methods: {
    // 预览
    previewImg () {
      this.previewDialogShow = true
    },
    // 查看教程
    showCourse () {
      this.$router.push({
        name: 'courseStep',
        query: {
          indexStep: 3,
          platform: 1
        }
      })
    },
    // 上一步
    prevStep () {
      this.$router.go(-1)
    },
    // 步骤三 提交订单 跳转页面
    entoOrderMerge () {
      this.$router.push({
        name: 'orderSubmit',
        query: {
          taskID: this.$route.query.readyTaskId
        }
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    let routeNames = ['pddBaseStepOne', 'courseStep', 'orderSubmit']
    if (routeNames.indexOf(from.name) !== -1) {
      next()
    } else {
      next({ name: 'souhuo' })
    }
  }
}
</script>

<style scoped>
  @import '../../step.scss';
  .tc_btn.primary{
    height: 38px;
    line-height: 38px;
    border: 1px solid #2c2c2c;
    color: #2c2c2c;
  }
</style>
